// @flow
import React from 'react';
import { useFormikContext } from 'formik';

import { TabsContainer } from '../../presentational/TabsContainer';
import { isAnythingEditedOnNativeInferencePoolPageBesidesTheGivenForm } from '../../cluster/cluster-details-inputs/utils';

import { NativeInferencePoolTotalSpendSummaryContainer } from './NativeInferencePoolTotalSpendSummaryContainer';
import { NativeInferencePoolMonthlySpendSummaryContainer } from './NativeInferencePoolMonthlySpendSummaryContainer';

export const NativeInferencePoolSummaryContainer = () => {
  const { values, initialValues } = useFormikContext();
  const disabled = isAnythingEditedOnNativeInferencePoolPageBesidesTheGivenForm(
    values,
    initialValues,
    null
  );

  const tabPanes = [
    {
      menuItem: 'Total Spend',
      render: () => <NativeInferencePoolTotalSpendSummaryContainer disabled={disabled} />,
    },
    {
      menuItem: 'Monthly Spend',
      render: () => <NativeInferencePoolMonthlySpendSummaryContainer disabled={disabled} />,
    },
  ];

  return <TabsContainer tabPanes={tabPanes} />;
};
